<template>
  <div>
    <div class="breadlist">
      <bread-list :routeQuery="routeQuery"></bread-list>
    </div>
    <div class="teacher-detail">
      <div class="teacher-top fs-lg d-flex">
        <div class="basic-img">
          <img
            :src="getBookCover(bookData.coverFile.path)"
            @error="headError"
          />
          <div class="polygon-one"></div>
          <div class="polygon-two"></div>
          <div class="polygon-three"></div>
          <div class="polygon-four"></div>
          <div class="polygon-five"></div>
        </div>
        <div class="basic-info weight">
          <div class="line d-flex">
            <div class="label">教&nbsp;&nbsp;&nbsp;材：</div>
            {{ bookData.name }}
          </div>
          <div class="line d-flex">
            <div class="label">课&nbsp;&nbsp;&nbsp;程：</div>
            {{ bookData.courseName }}
          </div>
          <div class="line d-flex">
            <div class="label">作&nbsp;&nbsp;&nbsp;者：</div>
            {{ bookData.teacherName }}
          </div>
          <div class="line d-flex">
            <div class="label">类&nbsp;&nbsp;&nbsp;型：</div>
            {{ bookData.typeName }}
          </div>
        </div>
      </div>
      <div style="margin-top: 16px">
        <div class="item d-flex">
          <div class="item-logo"></div>
          <div class="item-title weight fs-lg">简介</div>
        </div>
        <div class="item-content" v-html="bookData.content"></div>
      </div>
      <div style="margin-top: 16px">
        <div class="item d-flex">
          <div class="item-logo"></div>
          <div class="item-title weight fs-lg">教材附件</div>
        </div>
        <div class="item-content">
          <div
            v-for="(item, index) in bookData.materialFiles"
            :key="'files_' + index"
            class="each-file"
          >
            <a :href="item.path" target="_blank"
              >{{ index + 1 }} 、{{ item.name }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BreadList from '../../components/BreadList/indexnew.vue'
import { getMaterialInfo } from '@/api/api-teaching'
export default {
  components: {
    BreadList,
  },
  data() {
    return {
      bookData: {
        name: '',
        author: '',
        publish: '',
        bookCover: '',
        content: '',
      },
      routeQuery: '',
      bookId: '',
    }
  },
  created() {
    this.routeQuery = this.$route.query
    this.routeQuery.path1 = '/teaching'
    this.routeQuery.path2 = '/video'
    this.routeQuery.three = '教材详情'
    this.routeQuery.keepalive = 0
    this.bookId = this.routeQuery.bookId
    this.getDetail()
  },
  computed: {
    getBookCover() {
      return function (item) {
        if (item == null || item == '') {
          return 'http://cdn.uviewui.com/uview/empty/data.png'
        } else {
          return item
        }
      }
    },
  },
  methods: {
    headError(e) {
      e.target.src = 'http://cdn.uviewui.com/uview/empty/data.png'
    },
    getDetail() {
      getMaterialInfo(this.bookId).then((res) => {
        if (res.data.statusCode == 1) {
          this.bookData = res.data.obj
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.breadlist {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
.teacher-detail {
  width: 980px;
  padding: 24px 60px;
  margin: 0 auto;
  color: #181818;
}
.basic-img {
  position: relative;
  max-width: 456px;
  height: 330px;
  img {
    width: 100%;
    height: 100%;
  }
}
.basic-info {
  width: calc(100% - 504px);
  padding: 24px;
  color: #2f2f2f;
  .line {
    width: 100%;
    margin-bottom: 26.5px;
  }
  .label {
    width: 80px;
  }
}
.item-logo {
  width: 4px;
  height: 25px;
  background: #80bca6;
  border-radius: 3px;
}
.item-title {
  line-height: 25px;
  color: #2f2f2f;
  margin-left: 10px;
}
.item-content {
  margin-top: 20px;
  font-size: 15px;
  color: #2f2f2f;
}
.polygon-one {
  //   background: #007a4d;
  //   opacity: 0.2;
  //   transform: matrix(0.98, -0.57, -0.15, 0.89, 0, 0);
  background: url('../../assets/img/Rectangle3.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 92px;
  top: -18px;
  left: -26px;
}
.polygon-two {
  background: url('../../assets/img/Rectangle1.svg') no-repeat;
  position: absolute;
  width: 108px;
  height: 120px;
  top: 600px;
  left: -170px;
}
.polygon-three {
  background: url('../../assets/img/Rectangle2.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 105px;
  top: 80px;
  left: 900px;
}
.polygon-four {
  background: url('../../assets/img/Rectangle4.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 86px;
  top: 180px;
  left: 850px;
}
.polygon-five {
  background: url('../../assets/img/Rectangle5.svg') no-repeat;
  position: absolute;
  width: 72px;
  height: 56px;
  top: 800px;
  left: 1100px;
}
.each-file {
  margin-top: 16px;
  a {
    text-decoration: none;
    color: #2f2f2f;
  }
}
</style>
